import React, { useEffect, useState, useContext } from "react";
import {
  Link as RouterLink,
  useParams,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  Box,
  Grid,
  Typography,
  Select,
  MenuItem,
  TextField,
  InputLabel,
  FormControl,
  Slider, Divider,
  Checkbox,
  FormControlLabel,
  ToggleButton,
  ToggleButtonGroup,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  InputAdornment,
  IconButton,
  Breadcrumbs,
  Link,
  Button,
  CircularProgress,
  Radio,
  RadioGroup,
  Snackbar,
  Alert,
  Fab,
  Drawer,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
import SearchIcon from "@mui/icons-material/Search";
import {
  Add,
  ChevronRight,
  Favorite,
  HdrPlus,
  Layers,
  PlusOne,
  Search,
  ShoppingCart,
  FilterList as FilterListIcon,
  Close as CloseIcon,
  ShoppingCartOutlined,
  FavoriteOutlined,
  FavoriteBorderOutlined,
} from "@mui/icons-material";
import CarouselSection from "../../components/carousel";
import BestsellerSlider from "../../components/bestsellerSlider";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import {
  fetchProducts,
  getTopSellingProducts,
  getTrendingProduct,
  addToCart,
  addToCartGuest,
  getCartDetails,
  getAuthToken,
  getWishListofUser,
  addToWishlist,
} from "../../services/apiCalls";
import { useDispatch, useSelector } from "react-redux";
import { addItemToCart } from "../../features/cart/cartThunks";
import {
  addWishlistItem,
  removeWishlistItem,
} from "../../features/wishlist/wishlistThunks";
import { useSnackbar } from "../../context/SnackbarContext";
import { useTranslation } from "../../hooks/useTranslation";
import { CurrencyContext } from "../../context/CurrencyContext";
import BestsellerList from "../../components/bestsellerList";
import BreadCrumb from "../../components/BreadCrumb";

const ProductsPage = () => {
  const [sort, setSort] = useState("Sort By");
  const [productsPerPage, setProductsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [availability, setAvailability] = useState("all");
  const [priceRange, setPriceRange] = useState([0, 0]);
  const [products, setproducts] = useState([]);
  const [displayMode, setDisplayMode] = useState("grid");
  const [hoveredProductId, setHoveredProductId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [totalProductCount, setTotalProductCount] = useState(0);
  const [trendingProducts, setTrendingProducts] = useState([]);
  const { categoryId } = useParams();
  // const [wishlistItems, setWishlistItems] = useState([]);
  const [isInWishlist, setIsInWishlist] = useState({});
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const translate = useTranslation();
  const { selectedCurrency } = useContext(CurrencyContext);

  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();

  const { items: wishlistItems, loading: wishlistLoading } = useSelector(
    (state) => state.wishlist
  );
  const { items: cartItems, loading: cartLoading } = useSelector(
    (state) => state.cart
  );

  const location = useLocation();
  const navigate = useNavigate();

  const previousUrl = location.state?.from || "/";
  const { subcategoryId, subcategoryName } = location.state || {};
  const [addingToCartId, setAddingToCartId] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    if (subcategoryName) {
      setSelectedSubCategory(subcategoryName);
    }

    fetchProducts(categoryId, subcategoryId);
  }, [categoryId, subcategoryId, subcategoryName]);

  useEffect(() => {
    const fetchGetProducts = async () => {
      setLoading(true);
      try {
        const response = await fetchProducts(categoryId);
        setproducts(response.data);
        setTotalProductCount(response.product_count);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGetProducts();
  }, [categoryId]);

  useEffect(() => {
    if (products.length > 0) {
      const allPrices = products.flatMap((product) => {
        return product.sales_price || 0;
      });

      const minPrice = Math.min(...allPrices);
      const maxPrice = Math.max(...allPrices);
      setPriceRange([minPrice, maxPrice]);
    }
  }, [products]);

  useEffect(() => {
    const fetchTrendingProducts = async () => {
      const response = await getTrendingProduct();
      setTrendingProducts(response.data);
    };

    fetchTrendingProducts();
  }, []);

  const handleSortChange = (event) => {
    setSort(event.target.value);
  };

  const handleProductsPerPageChange = (event) => {
    setProductsPerPage(event.target.value);
  };

  const handlePriceRangeChange = (event, newValue) => {
    setPriceRange(newValue);
  };

  const handlePriceInputChange = (type) => (event) => {
    const value = Number(event.target.value);
    if (type === "min") {
      setPriceRange([value, priceRange[1]]);
    } else {
      setPriceRange([priceRange[0], value]);
    }
  };

  const getSortedProducts = (products, sortType) => {
    const sortedProducts = [...products];
    switch (sortType) {
      case "priceAsc":
        return sortedProducts.sort((a, b) => a.sales_price - b.sales_price);
      case "priceDesc":
        return sortedProducts.sort((a, b) => b.sales_price - a.sales_price);
      default:
        return sortedProducts;
    }
  };

  const getCategoriesAndSubcategories = () => {
    const categoriesMap = new Map();

    products.forEach((product) => {
      try {
        const categoryName = translate(product.category?.name);
        const subCategoryName = product.sub_category
          ? translate(product.sub_category?.name)
          : null;

        if (!categoriesMap.has(categoryName)) {
          categoriesMap.set(categoryName, new Set());
        }

        if (subCategoryName) {
          categoriesMap.get(categoryName).add(subCategoryName);
        }
      } catch (e) {
        console.error("Error parsing category/subcategory:", e);
      }
    });

    return Object.fromEntries(
      Array.from(categoriesMap.entries()).map(([category, subcategories]) => [
        category,
        Array.from(subcategories),
      ])
    );
  };

  const getBrands = () => {
    const brandsSet = new Set();
    products.forEach((product) => {
      if (product.brand?.name) {
        try {
          const brandName = translate(product.brand.name);
          if (brandName) brandsSet.add(brandName);
        } catch (e) {
          console.error("Error parsing brand name:", e);
        }
      }
    });
    return Array.from(brandsSet);
  };

  const getFilteredProducts = () => {
    let filtered = [...products];

    if (searchTerm) {
      filtered = filtered.filter((product) =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (selectedSubCategory) {
      filtered = filtered.filter((product) => {
        try {
          const subCategoryName = product.sub_category
            ? translate(product.sub_category?.name)
            : null;
          return subCategoryName === selectedSubCategory;
        } catch (e) {
          return false;
        }
      });
    }

    if (availability !== "all") {
      filtered = filtered.filter((product) => {
        if (availability === "in_stock") {
          return product.total_stock > 0;
        } else {
          return product.total_stock <= 0;
        }
      });
    }

    filtered = filtered.filter((product) => {
      const basePrice = product.sales_price || 0;

      const lowestPrice = Math.min(basePrice);

      return lowestPrice >= priceRange[0] && lowestPrice <= priceRange[1];
    });

    if (selectedBrand) {
      filtered = filtered.filter((product) => {
        try {
          const brandName = product.brand
            ? translate(product.brand.name)
            : null;
          return brandName === selectedBrand;
        } catch (e) {
          return false;
        }
      });
    }

    return getSortedProducts(filtered, sort);
  };

  const handleDisplayModeChange = (event, newDisplayMode) => {
    if (newDisplayMode) setDisplayMode(newDisplayMode);
  };

  const getPriceRange = (products) => {
    if (products.length === 0) return { lowest: null, highest: null };

    let lowest = products[0].price;
    let highest = products[0].price;

    products.forEach((product) => {
      if (product.price < lowest) lowest = product.price;
      if (product.price > highest) highest = product.price;
    });

    return { lowest, highest };
  };

  const realPriceRange = getPriceRange(products);

  const getProductsPerPageOptions = (totalCount) => {
    const options = [];
    if (totalCount >= 10) options.push(10);
    if (totalCount >= 20) options.push(20);
    if (totalCount >= 50) options.push(50);
    if (totalCount >= 100) options.push(100);

    if (options.length === 0) {
      options.push(totalCount);
    }

    return options;
  };

  const handleAddToCart = async (product) => {
    try {
      if (product.total_stock <= 0) {
        showSnackbar("Out of stock", "error");
        return;
      }

      if (product.product_variation_combination?.length > 0) {
        navigate(`/product/${product.id}`);
        return;
      }

      const cartItem = {
        product_id: product.id,
        quantity: "1",
        unit_price: product.sales_price.toString(),
        line_discount_type: "percentage",
        discount: product.discount || "",
      };

      await dispatch(addItemToCart(cartItem)).unwrap();
      showSnackbar("Added to cart successfully", "success");
    } catch (error) {
      showSnackbar("Failed to add to cart", "error");
    }
  };

  const handleWishlistAction = async (product) => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/signin");
      return;
    }

    try {
      const isProductInWishlist = wishlistItems.some(
        (item) => item.id === product.id
      );

      if (isProductInWishlist) {
        const wishlistItem = wishlistItems.find(
          (item) => item.id === product.id
        );
        await dispatch(removeWishlistItem(wishlistItem.wishlist_id)).unwrap();
      } else {
        await dispatch(addWishlistItem(product.id)).unwrap();
      }

      showSnackbar(
        isProductInWishlist ? "Removed from wishlist" : "Added to wishlist",
        "success"
      );
    } catch (error) {
      showSnackbar("Failed to update wishlist", "error");
    }
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        <CircularProgress />
        <Typography variant="h6" mt={2}>
          Loading Products...
        </Typography>
      </Box>
    );
  }
  const breadcrumbUrls = [
    // { path: '/previous', label: 'Back' },
    { path: '/', label: 'Home' },
    { path: '/products/1', label: 'Products' },
  ];

  return (
    <Box>
      <BreadCrumb title="Products" urls={breadcrumbUrls} />
      <Box sx={{
        display: "flex", padding: "20px 0", alignItems: "start", gap: 4,
        justifyContent: "center",
      }}>
        <Box
          sx={{
            backgroundColor: "#f9f9f9",

            width: { lg: "20%", md: "40%" },
            // paddingRight: "2.5em",
            display: { xs: "none", md: "block" },
          }}
        >
          <Typography variant="h4" fontWeight="bold" fontSize="1.5rem" sx={{ padding: "1.5rem 0", textAlign: "center" }}>
            {products[0]?.category
              ? translate(products[0]?.category?.name)
              : "Products"}
          </Typography>

          <Box sx={{ backgroundColor: "#f9f9f9" }}>
            <Accordion
              expanded={subcategoryName?.length}
              sx={{ boxShadow: "none", backgroundColor: "#f9f9f9", }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography fontSize="1.2rem" fontWeight="600" fontFamily="'Playfair Display', serif">Subcategories</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <FormControl fullWidth>
                    {/* <InputLabel>Subcategory</InputLabel> */}
                    {/* <Select
                      value={selectedSubCategory}
                      onChange={(e) => setSelectedSubCategory(e.target.value)}
                      label="Subcategory"
                    >
                      <MenuItem value="">All Subcategories</MenuItem>
                      {products[0]?.category &&
                        getCategoriesAndSubcategories()[
                          translate(products[0]?.category?.name)
                        ]?.map((subCategory) => (
                          <MenuItem key={subCategory} value={subCategory}>
                            {subCategory}
                          </MenuItem>
                        ))}
                    </Select> */}
                    <ul style={{ listStyleType: "none", padding: 0, margin: 0, fontFamily: "'Nunito Sans', sans-serif" }}>
                      <li
                        key="all"
                        onClick={() => setSelectedSubCategory("")}
                        style={{
                          cursor: "pointer",
                          padding: "8px",
                          backgroundColor: selectedSubCategory === "" ? "#f0f0f0" : "transparent",
                          color: selectedSubCategory === "" ? "#9e6747" : "#000",
                          borderBottom: "1px solid #ddd", // Divider
                        }}
                      >
                        All Subcategories
                      </li>
                      {products[0]?.category &&
                        getCategoriesAndSubcategories()[
                          translate(products[0]?.category?.name)
                        ]?.map((subCategory, index, array) => (
                          <li
                            key={subCategory}
                            onClick={() => setSelectedSubCategory(subCategory)}
                            style={{
                              cursor: "pointer",
                              padding: "8px",
                              backgroundColor:
                                selectedSubCategory === subCategory ? "#f0f0f0" : "transparent",
                              color: selectedSubCategory === subCategory ? "#9e6747" : "#000",
                              borderBottom: index !== array.length - 1 ? "1px solid #ddd" : "none", // Divider for all except the last item
                            }}
                          >
                            {subCategory}
                          </li>
                        ))}
                    </ul>


                  </FormControl>
                </Box>
              </AccordionDetails>
            </Accordion>

            <Divider />

            <Accordion sx={{ boxShadow: "none", backgroundColor: "#f9f9f9" }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>

                <Typography fontSize="1.2rem" fontWeight="600" fontFamily="'Playfair Display', serif">Brands</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <FormControl fullWidth>
                    {/* <InputLabel>Brand</InputLabel> */}
                    {/* <Select
                      value={selectedBrand}
                      onChange={(e) => setSelectedBrand(e.target.value)}
                      label="Brand"
                    >
                      <MenuItem value="">All Brands</MenuItem>
                      {getBrands().map((brand) => (
                        <MenuItem key={brand} value={brand}>
                          {brand}
                        </MenuItem>
                      ))}
                    </Select> */}
                    <ul style={{ listStyleType: "none", padding: 0, margin: 0, fontFamily: "'Nunito Sans', sans-serif" }}>
                      <li
                        key="all"
                        onClick={() => setSelectedBrand("")}
                        style={{
                          cursor: "pointer",
                          padding: "8px",
                          backgroundColor: selectedBrand === "" ? "#f0f0f0" : "transparent",
                          color: selectedBrand === "" ? "#9e6747" : "#000",
                          borderBottom: "1px solid #ddd", // Divider
                        }}
                      >
                        All Brands
                      </li>
                      {getBrands().map((brand, index, array) => (
                        <li
                          key={brand}
                          onClick={() => setSelectedBrand(brand)}
                          style={{
                            cursor: "pointer",
                            padding: "8px",
                            backgroundColor: selectedBrand === brand ? "#f0f0f0" : "transparent",
                            color: selectedBrand === brand ? "#9e6747" : "#000",
                            borderBottom: index !== array.length - 1 ? "1px solid #ddd" : "none", // Divider for all except the last item
                          }}
                        >
                          {brand}
                        </li>
                      ))}
                    </ul>


                  </FormControl>
                </Box>
              </AccordionDetails>
            </Accordion>

            {/* <Accordion sx={{ boxShadow: "none", backgroundColor: "#f9f9f9" }}>
              <AccordionSummary expandIcon={<Add />}>
                <Typography fontWeight="600" fontFamily="'Playfair Display', serif">Availability</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <FormControl component="fieldset">
                    <RadioGroup
                      value={availability}
                      onChange={(e) => setAvailability(e.target.value)}
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio />}
                        label="All Products"
                      />
                      <FormControlLabel
                        value="in_stock"
                        control={<Radio />}
                        label="In Stock"
                      />
                      <FormControlLabel
                        value="out_of_stock"
                        control={<Radio />}
                        label="Out of Stock"
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </AccordionDetails>
            </Accordion> */}
            <Box
              width="80%"
              margin="20px"
            >
              <Typography
                fontSize="1.2rem"
                fontWeight="600"
                fontFamily="'Playfair Display', serif"
              >
                Availability
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <FormControl component="fieldset">
                  <RadioGroup
                    value={availability}
                    onChange={(e) => setAvailability(e.target.value)}
                  >
                    <FormControlLabel
                      value="all"
                      control={<Radio />}
                      label="All Products"
                    />
                    <FormControlLabel
                      value="in_stock"
                      control={<Radio />}
                      label="In Stock"
                    />
                    <FormControlLabel
                      value="out_of_stock"
                      control={<Radio />}
                      label="Out of Stock"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Box>

            {/* <Accordion sx={{ boxShadow: "none", backgroundColor: "#f9f9f9" }}>
              <AccordionSummary expandIcon={<Add />}>
                <Typography fontWeight="600" fontFamily="'Playfair Display', serif">Price Range</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  fontSize={"16px"}
                  fontWeight={"400"}
                  color={"#1e1e1e"}
                  textAlign="left"
                  sx={{ marginBottom: "4px" }}
                >
                  Price Range: {selectedCurrency.code} {priceRange[0]} -  {selectedCurrency.code} {priceRange[1]}
                </Typography>
                <Slider
                  value={priceRange}
                  onChange={handlePriceRangeChange}
                  valueLabelDisplay="auto"
                  min={Math.min(...products.map((p) => p.sales_price || 0))}
                  max={Math.max(...products.map((p) => p.sales_price || 0))}
                />
                <Box display={"flex"} gap={3} flexDirection={"row"}>
                  <Box>
                    <Typography
                      fontSize={"16px"}
                      fontWeight={"400"}
                      color={"#1e1e1e"}
                      textAlign="left"
                      sx={{ marginBottom: "4px" }}
                    >
                      From {selectedCurrency.code}
                    </Typography>
                    <TextField
                      variant="outlined"
                      type="number"
                      value={priceRange[0]}
                      onChange={handlePriceInputChange("min")}
                      fullWidth
                      sx={{
                        border: "none",
                        input: {
                          padding: "13px 20px",
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 0,
                          backgroundColor: "#f3f3f3",
                        },
                      }}
                    />
                  </Box>

                  <Box>
                    <Typography
                      fontSize={"16px"}
                      fontWeight={"400"}
                      color={"#1e1e1e"}
                      textAlign="left"
                      sx={{ marginBottom: "4px" }}
                    >
                      To  {selectedCurrency.code}
                    </Typography>
                    <TextField
                      variant="outlined"
                      type="number"
                      value={priceRange[1]}
                      onChange={handlePriceInputChange("max")}
                      fullWidth
                      sx={{
                        border: "none",
                        input: {
                          padding: "13px 20px",
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 0,
                          backgroundColor: "#f3f3f3",
                        },
                      }}
                    />
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion> */}

            <Box
              width="80%"
              margin="20px"
            >
              <Typography fontSize="1.2rem" fontWeight="600" fontFamily="'Playfair Display', serif">Filter by Price</Typography>

              <Slider
                value={priceRange}
                onChange={handlePriceRangeChange}
                valueLabelDisplay="auto"
                min={Math.min(...products.map((p) => p.sales_price || 0))}
                max={Math.max(...products.map((p) => p.sales_price || 0))}
              />
              <Typography
                fontSize={"16px"}
                fontWeight={"400"}
                color={"#1e1e1e"}
                textAlign="left"
                sx={{ marginBottom: "4px" }}
              >
                Range: {selectedCurrency.code} {priceRange[0]} -  {selectedCurrency.code} {priceRange[1]}
              </Typography>
              <Box display={"flex"} gap={3} flexDirection={"row"}>
                <Box>
                  <Typography
                    fontSize={"16px"}
                    fontWeight={"400"}
                    color={"#1e1e1e"}
                    textAlign="left"
                    sx={{ marginBottom: "4px" }}
                  >
                    From {selectedCurrency.code}
                  </Typography>
                  <TextField
                    variant="outlined"
                    type="number"
                    value={priceRange[0]}
                    onChange={handlePriceInputChange("min")}
                    fullWidth
                    sx={{
                      border: "none",
                      input: {
                        padding: "13px 20px",
                      },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 0,
                        backgroundColor: "#f3f3f3",
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography
                    fontSize={"16px"}
                    fontWeight={"400"}
                    color={"#1e1e1e"}
                    textAlign="left"
                    sx={{ marginBottom: "4px" }}
                  >
                    To  {selectedCurrency.code}
                  </Typography>
                  <TextField
                    variant="outlined"
                    type="number"
                    value={priceRange[1]}
                    onChange={handlePriceInputChange("max")}
                    fullWidth
                    sx={{
                      border: "none",
                      input: {
                        padding: "13px 20px",
                      },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 0,
                        backgroundColor: "#f3f3f3",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
          <Box padding={"2em 0 0"}>
            {/* <BestsellerSlider /> */}
            <BestsellerList />
          </Box>
          <Box
            sx={{
              backgroundColor: "#f5f5f5",
              padding: "2em 1em",
              borderRadius: 0,
            }}
          >
            <Typography
              fontSize={"20px"}
              fontWeight={"600"}
              color={"#1e1e1e"}
              textAlign="left"
              sx={{ marginBottom: "8px", padding: "0 1em 1.5em" }}
            >
              Today's Trends
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "16px",
                padding: "16px",
                borderRadius: 0,
                // backgroundColor: "#ffffff",
                // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                cursor: "pointer",
                transition: "all 0.3s ease",
                ":hover": {
                  boxShadow: "0 6px 18px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              <Box
                component="img"
                src={trendingProducts.thumbnail}
                alt={trendingProducts.name}
                sx={{
                  width: { xs: "5rem", md: "7rem", lg: "7rem" },
                  height: "auto",
                  borderRadius: 0,
                }}
              />

              <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                <Typography
                  fontSize={"12px"}
                  fontWeight={"600"}
                  color={"#1e1e1e"}
                  textAlign="left"
                  fontFamily={"'Playfair Display', serif"}
                  sx={{
                    marginBottom: "8px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {trendingProducts.name}
                </Typography>

                <RouterLink to={`/product/${trendingProducts.id}`}>
                  <Button
                    sx={{
                      backgroundColor: "#000",
                      padding: ".4em 1em",
                      borderRadius: 0,
                      textTransform: "unset",
                      fontSize: "14px",
                      fontWeight: "500",
                      ":hover": {
                        backgroundColor: "#9e6747",
                      },
                    }}
                    variant="contained"
                  >
                    Shop Now
                  </Button>
                </RouterLink>
              </Box>
            </Box>

          </Box>
        </Box>

        <Box sx={{ width: { lg: "80%", md: "60%", xs: "100%" } }}>
          {/* <Box
            sx={{
              marginBottom: "30px",
              padding: "30px",
              border: "1px solid #e9e9e9",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: "#666",
                marginTop: 1,
              }}
            >
              {totalProductCount} Products available
            </Typography>
          </Box> */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            {/* <ToggleButtonGroup
              value={displayMode}
              exclusive
              onChange={handleDisplayModeChange}
              aria-label="Display Mode"
              sx={{
                alignItems: "center",
              }}
            >
              <Typography
                variant="body1"
                // fontWeight="500"
                textAlign="left"
                sx={{ marginRight: "8px" }}
              >
                Displayed As
              </Typography>
              <ToggleButton
                sx={{
                  "&.Mui-selected": {
                    color: "#ffffff",
                    backgroundColor: "#2189ff",
                    "&:hover": {
                      backgroundColor: "#0066cc",
                    },
                  },
                }}
                value="grid"
                aria-label="Grid View"
              >
                <ViewModuleIcon />
              </ToggleButton>
              <ToggleButton
                sx={{
                  "&.Mui-selected": {
                    color: "#ffffff",
                    backgroundColor: "#2189ff",
                    "&:hover": {
                      backgroundColor: "#0066cc",
                    },
                  },
                }}
                value="list"
                aria-label="List View"
              >
                <ViewListIcon />
              </ToggleButton>
            </ToggleButtonGroup> */}

            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select
                value={productsPerPage}
                variant="filled"
                onChange={handleProductsPerPageChange}
                sx={{
                  "&.MuiFilledInput-root": {
                    ".MuiSelect-select": {
                      padding: "10px 30px 10px 20px",
                      color: "#fff",
                    },
                    ".MuiSvgIcon-root": {
                      color: "#fff",
                    },
                    backgroundColor: "#9E6747",
                    "&:hover": {
                      backgroundColor: "#9E6747",
                    },
                    "&.Mui-focused": {
                      backgroundColor: "#9E6747",
                    },
                  },
                }}
              >
                {getProductsPerPageOptions(totalProductCount).map((option) => (
                  <MenuItem key={option} value={option}>
                    {option} per page
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl
              sx={{ minWidth: 120, flexDirection: "row", alignItems: "center" }}
            >
              <Typography
                variant="body1"
                textAlign="left"
                sx={{ marginRight: "8px" }}
              >
                Sort by
              </Typography>
              <Select
                variant="filled"
                sx={{
                  "&.MuiFilledInput-root": {
                    ".MuiSelect-select": {
                      padding: "10px 30px 10px 20px",
                      color: "#fff",
                    },
                    ".MuiSvgIcon-root": {
                      color: "#fff",
                    },
                    backgroundColor: "#9E6747",
                    "&:hover": {
                      backgroundColor: "#9E6747",
                    },
                    "&.Mui-focused": {
                      backgroundColor: "#9E6747",
                    },
                  },
                }}
                value={sort}
                onChange={handleSortChange}
              >
                <MenuItem value="Sort By">None</MenuItem>
                <MenuItem value="priceAsc">Price: Low to High</MenuItem>
                <MenuItem value="priceDesc">Price: High to Low</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Grid
            container
            gap={"34px"}
            justifyContent={{ lg: "flex-start", md: "center", xs: "center" }}
            direction={displayMode === "grid" ? "row" : "column"}
          >
            {getFilteredProducts()
              .slice(0, productsPerPage)
              .map((product) => (
                <Box
                  key={product.id}
                  sx={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    minWidth: "250px",
                    width: { md: "30%", xs: "80%" },
                    padding: "20px",
                    borderRadius: 0,
                    // backgroundColor: "#f9f9f9",
                    // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    ":hover": {
                      // boxShadow: "0 6px 18px rgba(0, 0, 0, 0.2)",
                    },
                  }}
                  onMouseEnter={() => setHoveredProductId(product.id)}
                  onMouseLeave={() => setHoveredProductId(null)}
                >
                  {product.discount && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 10,
                        left: 10,
                        backgroundColor: "black",
                        color: "white",
                        padding: "2px 4px",
                        borderRadius: 0,
                        fontWeight: "bold",
                        zIndex: 1,
                        fontSize: "14px",
                      }}
                    >
                      -{product.discount}%
                    </Box>
                  )}
                  {product.total_stock <= 0 && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "40%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: "rgba(124, 143, 172, 0.90)",
                        color: "white",
                        width: "120px",
                        height: "120px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        fontWeight: "bold",
                        fontSize: "16px",
                        zIndex: 999,
                      }}
                    >
                      Out of Stock
                    </Box>
                  )}

                  <RouterLink to={`/product/${product.id}`}>
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        maxWidth: "360px",
                        borderRadius: 0,
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        component="img"
                        src={
                          product.thumbnailz ||
                          "https://placehold.co/360x340?text=Image+Not+Found"
                        }
                        alt={product.description}
                        sx={{
                          backgroundColor: "#f9f9f9",
                          width: "100%",
                          height: "300px",
                          objectFit: "contain",
                          transition: "opacity 0.5s ease",
                          opacity: hoveredProductId === product.id ? 0 : 1,
                        }}
                      />
                      <Box
                        component="img"
                        src={
                          product.images[0] ||
                          "https://placehold.co/360x340?text=Image+Not+Found"
                        }
                        alt={product.description}
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "300px",
                          objectFit: "contain",
                          transition: "opacity 0.5s ease",
                          opacity: hoveredProductId === product.id ? 1 : 0,
                        }}
                      />
                    </Box>

                    <Box
                      className="hover-icons"
                      sx={{
                        position: "absolute",
                        top: "45%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        display: "flex",
                        gap: "8px",
                        opacity: hoveredProductId === product.id ? 1 : 0,
                        visibility:
                          hoveredProductId === product.id
                            ? "visible"
                            : "hidden",
                        transition: "opacity 0.3s ease, visibility 0.3s ease",
                      }}
                    ></Box>

                    <Typography
                      variant="caption"
                      fontSize={"12px"}
                      color={"#bebebe"}
                      textAlign="left"
                      sx={{ letterSpacing: "1px", marginBottom: "4px" }}
                    >
                      {(() => {
                        try {
                          const category = translate(product.category?.name);
                          const subCategory = product.sub_category
                            ? translate(product.sub_category?.name)
                            : null;
                          return subCategory
                            ? `${category} > ${subCategory}`
                            : category;
                        } catch (e) {
                          return "";
                        }
                      })()}
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      textAlign="left"
                      fontFamily="'Playfair Display', serif"
                      fontSize="1rem"
                      sx={{
                        marginBottom: "8px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: "2",
                        WebkitBoxOrient: "vertical",
                        height: "48px",
                      }}
                    >
                      {product.name}
                    </Typography>
                    <Box
                      display={"flex"}
                      alignItems="center"
                      justifyContent="center"
                      // textAlign="left"
                      sx={{ marginTop: "auto" }}
                    >
                      <Box display="flex" alignItems="center" gap={1}>
                        {product.discount && (
                          <Typography
                            variant="body2"
                            fontFamily="'Nunito Sans', sans-serif"
                            fontSize="1rem"
                            sx={{
                              textDecoration: "line-through",
                              color: "#ababab",
                            }}
                          >
                            {selectedCurrency.code === "Rs"
                              ? `${product.currency} ${product.sales_price}`
                              : `${selectedCurrency.code} ${(product.sales_price / parseFloat(selectedCurrency.ratio)).toFixed(2)}`
                            }
                          </Typography>
                        )}
                        <Typography variant="body2"
                          fontFamily="'Nunito Sans', sans-serif"
                          fontSize="1rem"
                        >
                          {selectedCurrency.code === "Rs"
                            ? `${product.currency} ${(product.sales_price * (1 - product.discount / 100)).toFixed(2)}`
                            : `${selectedCurrency.code} ${((product.sales_price * (1 - product.discount / 100)) / parseFloat(selectedCurrency.ratio)).toFixed(2)}`
                          }
                        </Typography>

                      </Box>
                      {/* <ChevronRight
                        sx={{ color: "#2189ff", marginLeft: "8px" }}
                      /> */}
                    </Box>
                  </RouterLink>

                  <IconButton
                    onClick={() => handleAddToCart(product)}
                    // disabled={addingToCartId === product.id}
                    sx={{
                      position: "absolute",
                      top: "10%",
                      right: "5%",
                      transform: "translate(-50%, -50%)",
                      backgroundColor: "#fff",
                      color: "#000",
                      borderRadius: "50%",
                      border: "1px solid #000",
                      width: "40px",
                      height: "40px",
                      opacity: hoveredProductId === product.id ? 1 : 0,
                      visibility:
                        hoveredProductId === product.id ? "visible" : "hidden",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        color: "#fff",
                        backgroundColor: "#000",
                        border: "none",
                      },
                      zIndex: 2,
                    }}
                  >
                    {addingToCartId === product.id ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <ShoppingCartOutlined />
                    )}
                  </IconButton>

                  <IconButton
                    onClick={() => handleWishlistAction(product)}
                    sx={{
                      position: "absolute",
                      top: "20%",
                      right: "5%",
                      transform: "translate(-50%, -50%)",
                      backgroundColor: isInWishlist[product.id]
                        ? "#ff4646"
                        : "#fff",
                      color: "#000",
                      borderRadius: "50%",
                      border: "1px solid #000",
                      width: "40px",
                      height: "40px",
                      opacity: hoveredProductId === product.id ? 1 : 0,
                      visibility:
                        hoveredProductId === product.id ? "visible" : "hidden",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        color: "#fff",
                        backgroundColor: isInWishlist[product.id]
                          ? "#ff6b6b"
                          : "#000",
                        border: "none",
                      },
                      zIndex: 2,
                    }}
                  >
                    <FavoriteBorderOutlined />
                  </IconButton>
                  <IconButton
                    onClick={() => handleAddToCart(product)}
                    // disabled={addingToCartId === product.id}
                    sx={{
                      position: "absolute",
                      bottom: "30%",
                      // transform: "translate(-50%, -50%)",
                      borderRadius: 0,
                      backgroundColor: "#000",
                      color: "#fff",
                      width: "80%",
                      height: "40px",
                      opacity: hoveredProductId === product.id ? 1 : 0,
                      visibility:
                        hoveredProductId === product.id ? "visible" : "hidden",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "#9E6747",
                        border: "none",
                      },
                      zIndex: 2,
                    }}
                  >
                    {addingToCartId === product.id ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <ShoppingCartOutlined />
                    )}
                  </IconButton>
                </Box>
              ))}
          </Grid>
        </Box>
      </Box>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          display: { xs: "block", md: "none" },
          position: "fixed",
          top: "50%",
          left: 0,
          transform: "translateY(-50%)",
          zIndex: 1000,
        }}
      >
        <Fab
          color="primary"
          onClick={() => setFilterDrawerOpen(true)}
          sx={{
            backgroundColor: "#2189ff",
            borderRadius: 0,
            width: "40px",
            height: "50px",
            "&:hover": {
              backgroundColor: "#1976d2",
            },
          }}
        >
          <FilterListIcon sx={{ fontSize: "1.2rem" }} />
        </Fab>
      </Box>

      <Drawer
        anchor="left"
        open={filterDrawerOpen}
        onClose={() => setFilterDrawerOpen(false)}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            width: "85%",
            maxWidth: "360px",
            padding: 2,
            paddingTop: 0,
          },
        }}
      >
        <Box
          sx={{
            position: "sticky",
            top: 0,
            bgcolor: "background.paper",
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 2,
            }}
          >
            <Typography variant="h6">Filters</Typography>
            <IconButton onClick={() => setFilterDrawerOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>

        <Box sx={{}}>
          <Accordion
            expanded={subcategoryName?.length}
            sx={{ boxShadow: "none" }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight="600" fontFamily="'Playfair Display', serif">Subcategories</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <FormControl fullWidth>
                  {/* <InputLabel>Subcategory</InputLabel>
                  <Select
                    value={selectedSubCategory}
                    onChange={(e) => setSelectedSubCategory(e.target.value)}
                    label="Subcategory"
                  >
                    <MenuItem value="">All Subcategories</MenuItem>
                    {products[0]?.category &&
                      getCategoriesAndSubcategories()[
                        translate(products[0]?.category?.name)
                      ]?.map((subCategory) => (
                        <MenuItem key={subCategory} value={subCategory}>
                          {subCategory}
                        </MenuItem>
                      ))}
                  </Select> */}
                  <ul style={{ listStyleType: "none", padding: 0, margin: 0, fontFamily: "'Nunito Sans', sans-serif" }}>
                    <li
                      key="all"
                      onClick={() => setSelectedSubCategory("")}
                      style={{
                        cursor: "pointer",
                        padding: "8px",
                        backgroundColor: selectedSubCategory === "" ? "#f0f0f0" : "transparent",
                        color: selectedSubCategory === "" ? "#9e6747" : "#000",
                        borderBottom: "1px solid #ddd", // Divider
                      }}
                    >
                      All Subcategories
                    </li>
                    {products[0]?.category &&
                      getCategoriesAndSubcategories()[
                        translate(products[0]?.category?.name)
                      ]?.map((subCategory, index, array) => (
                        <li
                          key={subCategory}
                          onClick={() => setSelectedSubCategory(subCategory)}
                          style={{
                            cursor: "pointer",
                            padding: "8px",
                            backgroundColor:
                              selectedSubCategory === subCategory ? "#f0f0f0" : "transparent",
                            color: selectedSubCategory === subCategory ? "#9e6747" : "#000",
                            borderBottom: index !== array.length - 1 ? "1px solid #ddd" : "none", // Divider for all except the last item
                          }}
                        >
                          {subCategory}
                        </li>
                      ))}
                  </ul>

                </FormControl>
              </Box>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ boxShadow: "none" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight="600" fontFamily="'Playfair Display', serif">Brands</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <FormControl fullWidth>
                  {/* <InputLabel>Brand</InputLabel>
                  <Select
                    value={selectedBrand}
                    onChange={(e) => setSelectedBrand(e.target.value)}
                    label="Brand"
                  >
                    <MenuItem value="">All Brands</MenuItem>
                    {getBrands().map((brand) => (
                      <MenuItem key={brand} value={brand}>
                        {brand}
                      </MenuItem>
                    ))}
                  </Select> */}
                  <ul style={{ listStyleType: "none", padding: 0, margin: 0, fontFamily: "'Nunito Sans', sans-serif" }}>
                    <li
                      key="all"
                      onClick={() => setSelectedBrand("")}
                      style={{
                        cursor: "pointer",
                        padding: "8px",
                        backgroundColor: selectedBrand === "" ? "#f0f0f0" : "transparent",
                        color: selectedBrand === "" ? "#9e6747" : "#000",
                        borderBottom: "1px solid #ddd", // Divider
                      }}
                    >
                      All Brands
                    </li>
                    {getBrands().map((brand, index, array) => (
                      <li
                        key={brand}
                        onClick={() => setSelectedBrand(brand)}
                        style={{
                          cursor: "pointer",
                          padding: "8px",
                          backgroundColor: selectedBrand === brand ? "#f0f0f0" : "transparent",
                          color: selectedBrand === brand ? "#9e6747" : "#000",
                          borderBottom: index !== array.length - 1 ? "1px solid #ddd" : "none", // Divider for all except the last item
                        }}
                      >
                        {brand}
                      </li>
                    ))}
                  </ul>
                </FormControl>
              </Box>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ boxShadow: "none" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight="600" fontFamily="'Playfair Display', serif">Availability</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <FormControl component="fieldset">
                  <RadioGroup
                    value={availability}
                    onChange={(e) => setAvailability(e.target.value)}
                  >
                    <FormControlLabel
                      value="all"
                      control={<Radio />}
                      label="All Products"
                    />
                    <FormControlLabel
                      value="in_stock"
                      control={<Radio />}
                      label="In Stock"
                    />
                    <FormControlLabel
                      value="out_of_stock"
                      control={<Radio />}
                      label="Out of Stock"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ boxShadow: "none" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight="600" fontFamily="'Playfair Display', serif">Price Range</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                fontSize={"16px"}
                fontWeight={"400"}
                color={"#1e1e1e"}
                textAlign="left"
                sx={{ marginBottom: "4px" }}
              >
                Price Range:  {selectedCurrency.code} {priceRange[0]} - ${priceRange[1]}
              </Typography>
              <Slider
                value={priceRange}
                onChange={handlePriceRangeChange}
                valueLabelDisplay="auto"
                min={Math.min(...products.map((p) => p.price || 0))}
                max={Math.max(...products.map((p) => p.price || 0))}
              />
              <Box display={"flex"} gap={3} flexDirection={"row"}>
                <Box>
                  <Typography
                    fontSize={"16px"}
                    fontWeight={"400"}
                    color={"#1e1e1e"}
                    textAlign="left"
                    sx={{ marginBottom: "4px" }}
                  >
                    From $
                  </Typography>
                  <TextField
                    variant="outlined"
                    type="number"
                    value={priceRange[0]}
                    onChange={handlePriceInputChange("min")}
                    fullWidth
                    sx={{
                      border: "none",
                      input: {
                        padding: "13px 20px",
                      },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 0,
                        backgroundColor: "#f3f3f3",
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography
                    fontSize={"16px"}
                    fontWeight={"400"}
                    color={"#1e1e1e"}
                    textAlign="left"
                    sx={{ marginBottom: "4px" }}
                  >
                    To $
                  </Typography>
                  <TextField
                    variant="outlined"
                    type="number"
                    value={priceRange[1]}
                    onChange={handlePriceInputChange("max")}
                    fullWidth
                    sx={{
                      border: "none",
                      input: {
                        padding: "13px 20px",
                      },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 0,
                        backgroundColor: "#f3f3f3",
                      },
                    }}
                  />
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>

        </Box>
        <Box padding={"2em 0 0"}>
          {/* <BestsellerSlider /> */}
          <BestsellerList />
        </Box>
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            padding: "2em 1em",
            borderRadius: 0,
          }}
        >
          <Typography
            fontSize={"20px"}
            fontWeight={"600"}
            color={"#1e1e1e"}
            textAlign="left"
            sx={{ marginBottom: "8px", padding: "0 1em 1.5em" }}
          >
            Today's Trends
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "16px",
              padding: "16px",
              borderRadius: 0,
              // backgroundColor: "#ffffff",
              // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              cursor: "pointer",
              transition: "all 0.3s ease",
              ":hover": {
                boxShadow: "0 6px 18px rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            <Box
              component="img"
              src={trendingProducts.thumbnail}
              alt={trendingProducts.name}
              sx={{
                width: { xs: "5rem", md: "7rem", lg: "7rem" },
                height: "auto",
                borderRadius: 0,
              }}
            />

            <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <Typography
                fontSize={"12px"}
                fontWeight={"600"}
                color={"#1e1e1e"}
                textAlign="left"
                fontFamily={"'Playfair Display', serif"}
                sx={{
                  marginBottom: "8px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {trendingProducts.name}
              </Typography>

              <RouterLink to={`/product/${trendingProducts.id}`}>
                <Button
                  sx={{
                    backgroundColor: "#000",
                    padding: ".4em 1em",
                    borderRadius: 0,
                    textTransform: "unset",
                    fontSize: "14px",
                    fontWeight: "500",
                    ":hover": {
                      backgroundColor: "#9e6747",
                    },
                  }}
                  variant="contained"
                >
                  Shop Now
                </Button>
              </RouterLink>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default ProductsPage;